import { render, staticRenderFns } from "./ConnectCoinbasePrime.vue?vue&type=template&id=7d959a4f&"
import script from "./ConnectCoinbasePrime.vue?vue&type=script&lang=js&"
export * from "./ConnectCoinbasePrime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports